import { AuthGuard, CrudOp, partlistEntryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const PartlistView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  return (
    <AuthGuard authScope={partlistEntryAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense><LazyPartlistView projectId={projectId} subprojectId={subprojectId}/></Suspense>
    </AuthGuard>
  );
};

const LazyPartlistView = lazy(importView(
  () => import("../components/PartlistView"),
  (it) => it.PartlistView,
));
